import { useState, useRef } from 'react'
import { trackGoal } from 'fathom-client'
import Navbar from 'components/navbar'
import Layout from 'components/layout'
import Seo from 'components/seo'
import Pagetitle from 'components/pageTitle'
import Footer from 'components/footer'
import HCaptcha from '@hcaptcha/react-hcaptcha'

import Facebook from 'components/social/facebook'
import Instagram from 'components/social/instagram'
import Pinterest from 'components/social/pinterest'

import socialInfo from 'data/social'
import { servicesHomeData } from 'data/services'

export default function contact() {
  const [formData, setFormData] = useState({})
  const [response, setResponse] = useState({ type: '', message: '' })
  const captchaRef = useRef(null)

  const sendContact = (e) => {
    e.preventDefault()

    fetch('/api/sendMail', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.error) {
          trackGoal('KEWSAVTU', 0)
          return setResponse({ type: 'error', message: json.error })
        }
        trackGoal('ZULLFBEP', 0)
        setResponse({ type: 'done', message: 'Message envoyé !' })
        captchaRef.current.resetCaptcha()
        return setFormData({ name: '', message: '', mail: '', service: '', token: '', ekey: '' })
      })
  }

  return (
    <>
      <Seo
        title="Nous contacter"
        description="Contactez-nous, nous vous proposons des solutions adaptées à vos besoins pour faire de votre présence digitale un succès !"
        canonical="/contact"
        schema={({ fullTitle, description, url }) => ({
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          publisher: {
            '@id': 'https://ateliermilky.com#identity'
          },
          copyrightHolder: {
            '@id': 'https://ateliermilky.com#identity'
          },
          name: fullTitle,
          description: description,
          mainEntityOfPage: url
        })}
      />
      <div className="overflow-hidden">
        <Navbar />
        <main className="relative mt-12 md:mt-24">
          <Layout>
            <Pagetitle>Contact</Pagetitle>

            {/* <div className="flex justify-center mt-8">
            <p className="max-w-lg text-justify text-lg leading-tight">
              <span className="font-bold">Lorem ipsum</span> dolor sit amet, consectetuer Lorem ipsum dolor sit amet,
              consectetuer adipiscing elit, <span className="font-bold">sed diam</span>
              nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
            </p>
          </div> */}

            <div className="relative mt-24 border-2 border-transparent bg-yellow-50 px-8 py-16 md:px-40">
              <form onSubmit={sendContact}>
                <h2 className="text-center font-serif text-3xl font-medium">Prendre contact avec nous</h2>
                <div className="mt-12 space-y-5">
                  <div>
                    <label className="font-serif text-lg" htmlFor="name">
                      Nom
                    </label>
                    <input
                      value={formData.name}
                      onChange={(e) => setFormData((prev) => ({ ...prev, name: e.target.value }))}
                      id="name"
                      required
                      type="text"
                      className="focus:ring- w-full rounded-none border-b border-black bg-transparent focus:outline-none focus:ring-1 focus:ring-black focus:ring-offset-4 focus:ring-offset-yellow-50"
                    />
                  </div>
                  <div>
                    <label className="font-serif text-lg" htmlFor="email">
                      E-mail
                    </label>
                    <input
                      value={formData.mail}
                      onChange={(e) => setFormData((prev) => ({ ...prev, mail: e.target.value }))}
                      id="email"
                      required
                      className="w-full rounded-none border-b border-black bg-transparent focus:outline-none focus:ring-1 focus:ring-black focus:ring-offset-4 focus:ring-offset-yellow-50"
                    />
                  </div>

                  <div>
                    <label className="font-serif text-lg" htmlFor="sevice">
                      Service:
                    </label>
                    <div>
                      {servicesHomeData.map((thisService) => (
                        <div key={thisService.id}>
                          <label>
                            <input
                              type="radio"
                              value={thisService.name}
                              name="service"
                              checked={formData.service === thisService.name}
                              onChange={(e) => setFormData((prev) => ({ ...prev, service: e.target.value }))}
                            />{' '}
                            {thisService.name}
                          </label>
                        </div>
                      ))}
                      <div>
                        <label>
                          <input
                            type="radio"
                            value="autre"
                            name="service"
                            checked={formData.service === 'Autre'}
                            onChange={(e) => setFormData((prev) => ({ ...prev, service: 'Autre' }))}
                          />{' '}
                          Autre
                        </label>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="font-serif text-lg" htmlFor="message">
                      Détaillez votre projet et besoins
                    </label>
                    <textarea
                      value={formData.message}
                      onChange={(e) => setFormData((prev) => ({ ...prev, message: e.target.value }))}
                      id="message"
                      required
                      rows={parseInt(`${formData.message}`.split('\n').length + 3)}
                      className="textareaStripe w-full resize-y rounded-none focus:outline-none focus:ring-1 focus:ring-black focus:ring-offset-4 focus:ring-offset-yellow-50"
                    />
                  </div>
                </div>

                <div className="z-30 mt-4 flex justify-center">
                  <HCaptcha
                    ref={captchaRef}
                    sitekey={process.env.NEXT_PUBLIC_HCAPTCHA_KEY}
                    onVerify={(token, ekey) => setFormData((prev) => ({ ...prev, token, ekey }))}
                  />
                </div>

                {response.type === 'error' && <div>Une erreur est survenue: {response.message}</div>}

                {response.type === 'done' && <div>Votre message a été envoyé !</div>}

                <div className="mt-8 flex w-full justify-center">
                  <button
                    type="submit"
                    className="focus:ring-offser-2 border border-black px-4 pb-1.5 pt-2.5 text-lg uppercase leading-4 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-transparent">
                    Envoyer
                  </button>
                </div>
              </form>

              <div className="absolute -bottom-7 right-4 flex space-x-6 md:-right-7 md:bottom-12 md:flex-col md:space-x-0 md:space-y-6">
                {socialInfo.facebookURL && (
                  <a
                    href={socialInfo.facebookURL}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-orange-200 text-white focus:outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2">
                    <Facebook className="h-6 w-6" />
                  </a>
                )}
                {socialInfo.instagramURL && (
                  <a
                    href={socialInfo.instagramURL}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-orange-200 text-white focus:outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2">
                    <Instagram className="h-6 w-6" />
                  </a>
                )}
                {socialInfo.pinterestURL && (
                  <a
                    href={socialInfo.pinterestURL}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-orange-200 text-white focus:outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2">
                    <Pinterest className="h-6 w-6" />
                  </a>
                )}
              </div>

              <div className="absolute -top-10 left-1/2 md:-left-10">
                <div className="absolute -left-10 top-0 inline-flex h-20 w-20 items-center justify-center rounded-full border border-orange bg-transparent text-orange md:left-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 34 34"
                    className="h-10 w-10"
                    stroke="currentColor">
                    <path strokeWidth={1.5} d="M32 17H17M17 17H2M17 17V2M17 17V32.5" />
                  </svg>
                </div>
              </div>

              {/* <div className="absolute -right-8 bottom-12 w-16 h-16 bg-orange-200 rounded-full"></div>
            <div className="absolute -right-8 bottom-16 w-16 h-16 bg-orange-200 rounded-full"></div>
            <div className="absolute -right-8 bottom-24 w-16 h-16 bg-orange-200 rounded-full"></div> */}

              <p
                className="absolute -left-48 top-80 rotate-90 transform font-serif text-7xl font-medium text-yellow"
                aria-hidden="true">
                Get in touch
              </p>
            </div>
          </Layout>
        </main>
        <div className="mt-32">
          <Footer />
        </div>
      </div>
    </>
  )
}
